<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png" /> -->

  <!-- <HelloWorld msg="Hello Vue 3.0 + Vite" /> -->
  <Home />
  <!-- <Test title="HAHA" message="HAHAHA" /> -->
</template>

<script>
import Home from "./components/Home.vue";

export default {
  name: "App",
  components: {
    Home,
  },
};
</script>
